export const REPORTS_LIST_KEY = 'reports_list';
export const REPORT_DETAILS = 'reports_details';
export const REPORT_NAME = 'report_name';
